import { render } from "./LeaderboardView.vue?vue&type=template&id=445d9524&scoped=true"
import script from "./LeaderboardView.vue?vue&type=script&lang=js"
export * from "./LeaderboardView.vue?vue&type=script&lang=js"

import "./LeaderboardView.vue?vue&type=style&index=0&id=445d9524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445d9524"]])

export default __exports__